import { ReactNode, createContext, useContext, useReducer } from "react";

import { InitialContext } from "../types/state/context";
import {
  MasterArtworkPrintingTechniqueActionTypes,
  MasterArtworkPrintingTechniqueState,
} from "../states/meta-artwork/printing-technique/data.type";
import { MasterArtworkPrintingTechniqueReducer } from "../states/meta-artwork/printing-technique";

type Context = InitialContext<MasterArtworkPrintingTechniqueState, MasterArtworkPrintingTechniqueActionTypes>;

export const MasterArtworkPrintingTechniqueContext = createContext<Context>({} as Context);

export function MasterArtworkPrintingTechniqueProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(
    MasterArtworkPrintingTechniqueReducer.reducer,
    MasterArtworkPrintingTechniqueReducer.initialState,
  );

  return (
    <MasterArtworkPrintingTechniqueContext.Provider value={{ state, dispatch }}>
      {children}
    </MasterArtworkPrintingTechniqueContext.Provider>
  );
}

export const useMasterArtworkPrintingTechniqueStore = () => useContext(MasterArtworkPrintingTechniqueContext);
